export const SOCKET_URL =
	process.env.REACT_APP_SOCKET_URL ||
	"wss://rppg-prod.xyz/vp/bgr_signal_socket";
export const AUTH_TOKEN =
	process.env.REACT_APP_AUTH_TOKEN || "c685b351-e1b6-4ee8-aa97-7ee80dda52ea";
